import React from "react";

const StampPortfolio = () => {
  return (
    <svg
      fill="#000000"
      width="800px"
      height="800px"
      viewBox="0 0 31 31"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className="svg-stamp-from-portfolio"
    >
      <path d="M6.489 26.141c0.15 0.069 0.326 0.109 0.511 0.109 0.505 0 0.94-0.299 1.137-0.73l0.003-0.008 4.298-9.596 3.705 1.267c0.121 0.043 0.261 0.068 0.406 0.068 0.359 0 0.682-0.152 0.909-0.395l0.001-0.001 6.291-6.698v1.389c0 0.69 0.56 1.25 1.25 1.25s1.25-0.56 1.25-1.25v0-4.546l-0.004-0.019c-0.009-0.112-0.031-0.217-0.065-0.315l0.003 0.009c-0.011-0.066-0.024-0.123-0.041-0.179l0.002 0.009c-0.032-0.056-0.065-0.104-0.101-0.149l0.002 0.003c-0.052-0.096-0.112-0.18-0.181-0.254l0.001 0.001-0.011-0.016c-0.045-0.034-0.097-0.066-0.151-0.095l-0.006-0.003c-0.139-0.125-0.323-0.203-0.526-0.206h-0.001c-0.048-0.014-0.106-0.026-0.166-0.034l-0.006-0.001h-4.545c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25v0h1.656l-5.922 6.307-4.020-1.375c-0.121-0.043-0.26-0.068-0.405-0.068-0.505 0-0.94 0.3-1.137 0.732l-0.003 0.008-4.764 10.635c-0.069 0.15-0.109 0.326-0.109 0.511 0 0.505 0.3 0.941 0.731 1.138l0.008 0.003zM30 28.75h-26.75v-26.75c0-0.69-0.56-1.25-1.25-1.25s-1.25 0.56-1.25 1.25v0 28c0 0.69 0.56 1.25 1.25 1.25h28c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25v0z"></path>
    </svg>
  );
};

export default StampPortfolio;
